import { styled } from 'styled-components';
import RoundedWrapper from '../RoundedWrapper';

export const RoundedWrapperStyled = styled(RoundedWrapper)`
  padding: 4rem;
  align-items: center;
`;

export const StepSubtitleStyled = styled.p`
  margin: 0;
  max-width: 55rem;
`;
